var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5170_47659)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5586 0.841797H7.55859V2.50846H12.5586V0.841797ZM9.22526 11.6751H10.8919V6.67513H9.22526V11.6751ZM15.9169 6.15846L17.1003 4.97513C16.7419 4.55013 16.3503 4.15013 15.9253 3.80013L14.7419 4.98346C13.4503 3.95013 11.8253 3.33346 10.0586 3.33346C5.91693 3.33346 2.55859 6.6918 2.55859 10.8335C2.55859 14.9751 5.90859 18.3335 10.0586 18.3335C14.2086 18.3335 17.5586 14.9751 17.5586 10.8335C17.5586 9.07513 16.9419 7.45013 15.9169 6.15846ZM10.0586 16.6751C6.83359 16.6751 4.22526 14.0668 4.22526 10.8418C4.22526 7.6168 6.83359 5.00846 10.0586 5.00846C13.2836 5.00846 15.8919 7.6168 15.8919 10.8418C15.8919 14.0668 13.2836 16.6751 10.0586 16.6751Z",
    fill: "#2990FB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5170_47659"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.768f9828ed94f8701ff7ffcde05bdf04.svg";
export { ForwardRef as ReactComponent };